import { apiFetch } from "./client";

export const accountApi = {
  getAccount: () => apiFetch("/account"),
  updateAddress: (payload) =>
    apiFetch("/account/address", {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  updatePassword: (payload) =>
    apiFetch("/account/password", {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  getAccessLogs: ({ startDate, endDate} = {}) => {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    const query = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/account/access-logs${query}`);
  },
};
